import { CheckCircle2, KeyRound, LoaderCircle } from "lucide-react";
import usePasswordChange from "../../hooks/usePasswordChange";
import PasswordFields from "./PasswordFields";

export default function PasswordChangeForm() {
  const { changeValue, error, state, updatePassword, values } = usePasswordChange();

  return (
    <form className="password-change-form" onSubmit={updatePassword} data-testid="admin-password-change-form">
      <PasswordFields values={values} onChange={changeValue} />
      <p className="password-policy" data-testid="admin-password-policy">
        Use 12 or more characters, including uppercase, lowercase, number, and symbol characters.
      </p>
      {error && <p className="form-error" data-testid="admin-password-change-error">{error}</p>}
      {state === "success" && <p className="password-success" data-testid="admin-password-change-success"><CheckCircle2 size={17} />Password updated. Other Control Room sessions must sign in again.</p>}
      <button className="button button--red" disabled={state === "loading"} data-testid="admin-password-change-submit-button">
        {state === "loading" ? <LoaderCircle className="spin" size={16} /> : <KeyRound size={16} />}
        {state === "loading" ? "Updating password…" : "Update password"}
      </button>
    </form>
  );
}